"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doubleString = doubleString;
exports.splitCamelCase = splitCamelCase;
function doubleString(string) {
  let stringResult = '';
  for (let index = 0; index < string.length; index += 1) {
    stringResult += string[index] + string[index];
  }
  return stringResult;
}
function splitCamelCase(name) {
  return name.replace(/([A-Z])/g, ' $1').trim();
}